
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/influencers/[influencers_category]/[page]",
      function () {
        return require("private-next-pages/sitemap/influencers/[influencers_category]/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/influencers/[influencers_category]/[page]"])
      });
    }
  